import React from "react";
import ClarkMachineCard from "./clarkMachineCard";

const ElectricStackerTrucks = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Elektrické zakladače</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-ws10mi.webp"
          imgAlt="Obrázek elektrického zakladače CLARK ws10mi"
          title="CLARK WS10Mi"
          loadCapacity="1 000 kg"
          drive="Elektrický"
          liftHeight="1 950 mm"
          maxSpeed="až 4 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/ws10mi?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-ws12m.webp"
          imgAlt="Obrázek elektrického zakladače CLARK ws12m"
          title="CLARK WS12M"
          loadCapacity="1 200 kg"
          drive="Elektrický"
          liftHeight="1 950 mm"
          maxSpeed="až 4 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/ws12m?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-ws12.webp"
          imgAlt="Obrázek elektrického zakladače CLARK ws12"
          title="CLARK WS12"
          loadCapacity="1 200 kg"
          drive="Elektrický"
          liftHeight="4 100 mm"
          maxSpeed="až 4 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/ws12?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-swx12.webp"
          imgAlt="Obrázek elektrického zakladače CLARK swx12"
          title="CLARK SWX12"
          loadCapacity="1 200 kg"
          drive="Elektrický"
          liftHeight="4 800 mm"
          maxSpeed="až 5.5 km/h"
          additionalInfo="Lithium-iontová baterie v ceně"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/swx12?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-swx16.webp"
          imgAlt="Obrázek elektrického zakladače CLARK swx16"
          title="CLARK SWX16"
          loadCapacity="1 600 kg"
          drive="Elektrický"
          liftHeight="5 500 mm"
          maxSpeed="až 5.5 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/swx16?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-swx16i.webp"
          imgAlt="Obrázek elektrického zakladače CLARK swx16i"
          title="CLARK SWX16i"
          loadCapacity="1 600 kg"
          drive="Elektrický"
          liftHeight="5 500 mm"
          maxSpeed="až 5.5 km/h"
          additionalInfo="Lithium-iontová baterie v ceně"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/swx16i?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-psx16.webp"
          imgAlt="Obrázek elektrického zakladače CLARK psx16"
          title="CLARK PSX16"
          loadCapacity="1 600 kg"
          drive="Elektrický"
          liftHeight="5 800 mm"
          maxSpeed="až 6 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/psx16?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-wsxd20.webp"
          imgAlt="Obrázek elektrického zakladače CLARK wsxd20"
          title="CLARK WSXD20"
          loadCapacity="2 000 kg"
          drive="Elektrický"
          liftHeight="3 900 mm"
          maxSpeed="až 6 km/h"
          link="https://clarkmheu-com.translate.goog/en/pallet-stackers/wsxd20?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
          sameHeightAsIfAdditionalInfo
        />
      </div>
    </div>
  );
};
export default ElectricStackerTrucks;
